function map() {
    let map = new BMap.Map("map"); // 创建Map实例
    let point = new BMap.Point(113.893629, 22.953063)
    map.centerAndZoom(point, 18); // 初始化地图,设置中心点坐标和地图级别
    map.setCurrentCity("东莞"); // 设置地图显示的城市 此项是必须设置的
    map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

    let marker = new BMap.Marker(point);
    let opts = {
        width: 200, // 信息窗口宽度
        height: 100, // 信息窗口高度
        title: "威迪股份", // 信息窗口标题
        enableMessage: true, //设置允许信息窗发送短息
    }
    let infoWindow = new BMap.InfoWindow("地址：东莞市松山湖高新技术产业开发区科技十路5号国际金融IT研发中心第13C 座", opts); // 创建信息窗口对象 
    map.openInfoWindow(infoWindow, point); //开启信息窗口
    marker.addEventListener("click", function() {
        map.openInfoWindow(infoWindow, point); //开启信息窗口
    });
    map.addOverlay(marker);
}

module.exports = map;


// WEBPACK FOOTER //
// ./js/page/map.js